import { render, staticRenderFns } from "./budget_report.vue?vue&type=template&id=48084933&scoped=true&"
import script from "./budget_report.vue?vue&type=script&lang=js&"
export * from "./budget_report.vue?vue&type=script&lang=js&"
import style0 from "./budget_report.vue?vue&type=style&index=0&id=48084933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48084933",
  null
  
)

export default component.exports